import axios from 'axios'
import { API_BASE, apiErrorHandler, ApiFilter } from '../api'
import Auth from '../auth'

const PAYROLL_REQUEST_URL = `${API_BASE}payroll-requests/`

export default class PayrollRequestAPI {
  constructor(cls) {
    this.cls = cls
  }

  static create(cls) {
    return new PayrollRequestAPI(cls)
  }

  /*
   * Create a new payroll request as an authenticated OR anonymous user.
   */
  create(payrollRequest, params = {}) {
    const data = this.cls.toAPI(payrollRequest)
    const paramsMap = {
      donorId: ApiFilter.create({ key: 'donor_id' }),
      magicToken: ApiFilter.create({ key: 'magic_token' }),
    }
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
      params: ApiFilter.buildParams(paramsMap, { ...params }),
    }
    return axios
      .post(PAYROLL_REQUEST_URL, data, options)
      .then(res => this.cls.fromAPI(res.data))
      .catch(apiErrorHandler({ apiName: 'Create Payroll Request API error' }))
  }

  async retrieve(payrollRequestId, params = {}) {
    const paramsMap = {
      donorId: ApiFilter.create({ key: 'donor_id' }),
      magicToken: ApiFilter.create({ key: 'magic_token' }),
    }
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
      params: ApiFilter.buildParams(paramsMap, { ...params }),
    }

    const url = `${PAYROLL_REQUEST_URL}${payrollRequestId}/`
    return axios
      .get(url, options)
      .then(response => response.data)
      .then(this.cls.fromAPI)
      .catch(apiErrorHandler({ apiName: 'Retrieve Payroll Request API error' }))
  }
}
